import { ConvertedOrder } from './getCartOrderConverter'

export const OrderButtonType = {
  PRIMARY: 'PRIMARY',
  SECONDARY: 'SECONDARY', // blue
  BASIC: 'BASIC',
} as const
export type TOrderButtonType = keyof typeof OrderButtonType

export const OrderButtonIconType = {
  QR: 'QR',
  TICKET: 'TICKET',
  CHAT: 'CHAT',
} as const
export type TOrderButtonIconType = keyof typeof OrderButtonIconType
export interface OrderButton {
  title: string
  id: string
  data?: any
  isDisabled?: boolean
  type: TOrderButtonType
  icon?: TOrderButtonIconType
}

export interface PurchaseBanner {
  title: string
  url: string
}

export interface ReceiptAdditionalOrderDetail {
  orderId: string
  orderedAt: string
  orderDetails: ConvertedOrder[]
}

export interface KinesisLogMetaId {
  hashOrderId: string
  hashCategoryOrderId: string
}
